import Vue from 'vue'
import pubAnimate from '@/components/public/pub-animate';

Vue.component('pub-animate', pubAnimate);
